module.exports = __webpack_public_path__ + "static/greenkeeper-465ad6613ea63467a88452fde477a4ec.png";